import { render, staticRenderFns } from "./partner_selected.vue?vue&type=template&id=85b21bf0&scoped=true"
import script from "./partner_selected.vue?vue&type=script&lang=js"
export * from "./partner_selected.vue?vue&type=script&lang=js"
import style0 from "./partner_selected.vue?vue&type=style&index=0&id=85b21bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b21bf0",
  null
  
)

export default component.exports